module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/business/bus-product-6-0b2ff836ec6851b8105cdbf58aeabc93.jpg";